import { useState } from "react";
import $ from "jquery";
import { logoutSession } from "../services/authServices";
import { useNavigate } from "react-router-dom";

function Sidebar() {
  const [collapse, toggleCollapse] = useState(false);
  const [subMenuCollapse, toggleSubMenuCollapse] = useState(true);
  const navigate = useNavigate();

  $(document).on("click", "li.nav-link", function () {
    const styling = "text-[#6f81f5] scale-[110%]";
    const hover = "hover:text-[#6f81f5] w-100";
    $("li.nav-link").removeClass(styling).addClass(hover);
    $(this).removeClass(hover).addClass(styling);
  });

  const handeLogout = async () => {
    await logoutSession();
    navigate("/login");
  };

  return (
    <div>
      <div
        className={`h-full min-h-screen overflow-hidden flex flex-col justify-start items-start pl-10 pt-8 text-start text-white z-[10] bg-white shadow-[0_3px_10px_rgb(0,0,0,0.2)] gap-16 text-nowrap ${
          collapse ? "w-[0px]" : "w-[300px]"
        } transition-all duration-500`}
      >
        <a href="/">
          <span className="text-[#6f81f5] text-3xl font-semibold">
            Company Logo
          </span>
        </a>
        <ul className="w-full text-[#585858] text-lg font-semibold flex flex-col gap-6">
          <li
            className="nav-link transition-all duration-250 origin-left hidden
"
          >
            <a href="#" aria-current="page">
              Start New Form
            </a>
          </li>
          <li
            className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left
"
          >
            <a href="/">Dashboard</a>
          </li>
          <li
            onClick={() => toggleSubMenuCollapse(!subMenuCollapse)}
            className="cursor-pointer"
          >
            Application Status {">"}
            <ul
              className={`font-normal text-md ml-5 flex flex-col gap-2 overflow-hidden ${
                subMenuCollapse ? "h-0" : "h-full"
              } transition-all duration-250 origin-top`}
            >
              <li className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left">
                <a href="/approved">Approved Forms</a>
              </li>
              <li className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left">
                <a href="/pending">Pending Forms</a>
              </li>
              <li className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left">
                <a href="/rejected">Rejected Forms</a>
              </li>
            </ul>
          </li>
          <li
            className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left
"
          >
            <a href="/remarks">Remarks</a>
          </li>
          <li
            className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left
"
          >
            <a href="/change-password">Settings</a>
          </li>
          <li
            className="nav-link hover:text-[#6f81f5] transition-all duration-250 origin-left
"
          >
            <a onClick={handeLogout} className="cursor-pointer">
              Log Out
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        id="collapse-btn"
        onClick={() => toggleCollapse(!collapse)}
        className={`h-[50px] w-[50px] bg-[#6f81f5] rounded-full absolute ${
          collapse ? "left-[15px]" : "left-[calc(300px-25px)]"
        } top-[calc(50%_-_25px)] transition-all duration-500`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          height="25"
          width="25"
          className={`mx-auto ${
            collapse ? "rotate-[-180deg]" : "rotate-[0deg]"
          } transition-all duration-750`}
        >
          <path
            fill="#fff"
            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
          />
        </svg>
      </button>
    </div>
  );
}

export default Sidebar;
